import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ApplicationFormData, UserFormData } from "@/api/application/application";
import { GeneralPage } from "./pages/GeneralPage";
import { ConsentPage } from "./pages/ConsentPage";
import { MedicalPage } from "./pages/MedicalPage";
import { ConfirmPage } from "./pages/ConfirmPage";

export type RegistryFormData = {
  application: ApplicationFormData;
  user: UserFormData;
};

export const defaultApplicationFormData: ApplicationFormData = {
  applicant_type: "self",
  applicant_is_adult: null,

  consent_locked: false,
  consent_health_collection: null,
  consent_health_sharing: null,
  consent_contact: null,
  consent_contact_email: null,
  consent_contact_phone: null,
  consent_contact_recurring: null,

  patient_date_of_birth: null,
  personal_country_of_residence: null,
  personal_travel_willing: null,

  proxy_country: null,
  proxy_state: null,
  proxy_date_of_birth: null,

  personal_no_patient_email: null,
  personal_patient_email: null,

  proxy_first_name: null,
  proxy_last_name: null,

  proxy_phone: null,
  patient_phone: null,

  patient_first_name: null,
  patient_last_name: null,
  patient_country: null,
  patient_state: null,

  vision_conditions: [],
  vision_macular_degeneration_type: null,
  vision_other_details: null,
  vision_acuity_known: null,
  vision_acuity_left: null,
  vision_acuity_right: null,
  vision_can_read_normal_print: null,
  vision_can_read_headlines: null,
  vision_can_see_indoors: null,
  vision_can_localize_person: null,
  vision_driving: null,

  additional_info: null,

  is_submitted: false,
  submitted_at: null,
};

export const defaultUserFormData: UserFormData = {
  first_name: "",
  last_name: "",
};

export const defaultRegistryFormData: RegistryFormData = {
  application: defaultApplicationFormData,
  user: defaultUserFormData,
};

export const hasSufficientConsent = (
  applicationData: Partial<ApplicationFormData> | null | undefined,
): boolean => {
  const requiredConsent = [
    applicationData?.consent_health_collection,
    applicationData?.consent_contact,
    applicationData?.consent_contact_email,
    applicationData?.consent_health_sharing,
  ];

  return requiredConsent.every((consent) => consent === true);
};

export const Registry = () => {
  return (
    <Routes>
      <Route index element={<GeneralPage />} />
      <Route path="consent" element={<ConsentPage />} />
      <Route path="medical" element={<MedicalPage />} />
      <Route path="confirm" element={<ConfirmPage />} />
      <Route path="*" element={<Navigate to="/registry" replace />} />
    </Routes>
  );
};
